/**
 * JeriCommerce Pass API · staging
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SetProgramLanguagesDto { 
    /**
     * List of enabled locale codes
     */
    locales: Array<SetProgramLanguagesDto.LocalesEnum>;
    /**
     * Default locale code
     */
    defaultLocale: SetProgramLanguagesDto.DefaultLocaleEnum;
}
export namespace SetProgramLanguagesDto {
    export const LocalesEnum = {
        En: 'en',
        Es: 'es',
        De: 'de',
        Fr: 'fr',
        It: 'it',
        Bg: 'bg',
        Ca: 'ca',
        Hu: 'hu'
    } as const;
    export type LocalesEnum = typeof LocalesEnum[keyof typeof LocalesEnum];
    export const DefaultLocaleEnum = {
        En: 'en',
        Es: 'es',
        De: 'de',
        Fr: 'fr',
        It: 'it',
        Bg: 'bg',
        Ca: 'ca',
        Hu: 'hu'
    } as const;
    export type DefaultLocaleEnum = typeof DefaultLocaleEnum[keyof typeof DefaultLocaleEnum];
}


